module.exports = __webpack_public_path__ + "static/media/tweet1.245658de.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tweets/tweet1.jpeg
// module id = 458
// module chunks = 0